import { useCallback } from "react";
import { useColorMode } from "@chakra-ui/react";

import ContractsCard from "@components/ContractsCard";
import usePageData from "@hooks/usePageData";

import {
  Binance_light,
  Fantom_light,
  Polygon_light,
  Near_light,
  Terra_light,
  Eth_light,
  Binance_dark,
  Fantom_dark,
  Polygon_dark,
  Near_dark,
  Terra_dark,
  Eth_dark,
} from "icons";

const Contracts = () => {
  const contractsData =
    usePageData(
      "$.page.data.right_sections.data[?(@.attributes.key=='contracts')]"
    )[0]?.attributes || {};
  const { colorMode } = useColorMode();

  const getBlockChainThemedIcon = useCallback(
    (blockchain: string = "") => {
      const chain = blockchain.toLowerCase();
      switch (chain) {
        case "polygon":
          return colorMode === "light" ? Polygon_light : Polygon_dark;
        case "binance":
          return colorMode === "light" ? Binance_light : Binance_dark;
        case "near":
          return colorMode === "light" ? Near_light : Near_dark;
        case "fantom":
          return colorMode === "light" ? Fantom_light : Fantom_dark;
        case "terra":
          return colorMode === "light" ? Terra_light : Terra_dark;
        case "eth":
          return colorMode === "light" ? Eth_light : Eth_dark;
      }
    },
    [colorMode]
  );

  const getContractItems = useCallback(
    (data: any) => {
      return data.map((item: any) => {
        return {
          address: item?.address,
          icon: getBlockChainThemedIcon(item?.title),
        };
      });
    },
    [getBlockChainThemedIcon]
  );

  return (
    <ContractsCard
      title={contractsData.title}
      contractItems={getContractItems(contractsData?.content?.[0]?.data) || []}
    />
  );
};

export default Contracts;
